export const fmtDate = (d) => {
  if (!d) return "—";
  const [y, m, dd] = String(d).slice(0, 10).split("-");
  return `${dd}/${m}/${y}`;
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  return new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const LICENSE_STATUS = {
  pending: { label: "In attesa di approvazione", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  active: { label: "Attiva", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  expired: { label: "Scaduta", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  suspended: { label: "Sospesa", cls: "bg-orange-50 text-orange-800 border-orange-200" },
  revoked: { label: "Revocata", cls: "bg-red-50 text-red-800 border-red-200" },
};

export const MEMBERSHIP_CLS = {
  Valido: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Scaduto: "bg-slate-100 text-slate-600 border-slate-200",
  Sospeso: "bg-orange-50 text-orange-800 border-orange-200",
  "Non rinnovato": "bg-red-50 text-red-800 border-red-200",
};

export const EVENT_STATUS_CLS = {
  Programmata: "bg-blue-50 text-blue-800 border-blue-200",
  "In corso": "bg-emerald-50 text-emerald-800 border-emerald-200",
  Conclusa: "bg-slate-100 text-slate-600 border-slate-200",
  Annullata: "bg-red-50 text-red-800 border-red-200",
};

export const OUTCOME_CLS = {
  AMMESSO: "bg-emerald-50 text-emerald-800 border-emerald-200",
  "NON AMMESSO": "bg-red-50 text-red-800 border-red-200",
  "GIÀ REGISTRATA": "bg-amber-50 text-amber-800 border-amber-200",
};

export const ROLE_LABELS = {
  admin: "Amministratore Nazionale",
  sector_manager: "Responsabile di Settore",
  organizer: "Organizzatore di Gara",
  athlete: "Atleta",
};

export const homeFor = (role) =>
  ({ admin: "/dashboard", sector_manager: "/dashboard", organizer: "/scanner", athlete: "/mia-licenza" })[role] || "/login";
